import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { SITE } from "../lib/siteConfig";

const WhatsAppGlyph = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91C21.95 6.45 17.5 2 12.04 2zm0 18.03c-1.48 0-2.93-.4-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.26 8.26 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.25-8.24 4.54 0 8.24 3.7 8.24 8.24 0 4.55-3.7 8.24-8.24 8.24zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.17.25-.64.8-.78.97-.14.16-.29.18-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.01-.38.11-.51.11-.11.25-.29.37-.43.12-.14.16-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.22.25-.86.85-.86 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.15-1.18-.06-.1-.23-.16-.48-.27z" />
  </svg>
);

export default function WhatsAppButton() {
  const [hover, setHover] = useState(false);
  const number = SITE.whatsapp.replace(/\D/g, "");
  const href = `https://wa.me/${number}?text=${encodeURIComponent(
    "Hi CREDNOVA, I would like assistance with a loan enquiry."
  )}`;

  return (
    <motion.div
      className="fixed bottom-[96px] right-5 lg:bottom-6 lg:right-6 z-50 flex items-center gap-3"
      initial={{ opacity: 0, scale: 0.6, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1.6, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
    >
      <AnimatePresence>
        {hover && (
          <motion.span
            initial={{ opacity: 0, x: 10 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 10 }}
            transition={{ duration: 0.25 }}
            className="hidden sm:block text-xs text-[#F4F4F6] bg-[#18181E] border border-[rgba(212,175,55,0.3)] rounded-full px-4 py-2 shadow-lg"
          >
            Chat with us on WhatsApp
          </motion.span>
        )}
      </AnimatePresence>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-chat-button"
        aria-label="Chat with CREDNOVA on WhatsApp"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        className="relative flex items-center justify-center w-14 h-14 rounded-full text-white transition-transform duration-300 hover:scale-110"
        style={{ background: "linear-gradient(135deg, #2BD46B 0%, #1FAF54 100%)", boxShadow: "0 8px 28px rgba(37, 211, 102, 0.35)" }}
      >
        <span
          className="absolute inset-0 rounded-full animate-ping opacity-20"
          style={{ background: "#25D366", animationDuration: "2.4s" }}
        />
        <span className="relative">
          <WhatsAppGlyph />
        </span>
      </a>
    </motion.div>
  );
}
